import Input from "../ui-components/Input";
import {useIntl} from "react-intl";
import {useState, useEffect} from "react";


const WorksiteImageDescription = ({
                                    imagesData,
                                    setImagesData,
                                    imageUrl,
                                    desImage
                                  }) => {

  const [image_description, setImageDescription] = useState();
  useEffect(() => {
    if (desImage) {
      setImageDescription(desImage)
    }
  }, [desImage, setImageDescription])
  const intl = useIntl();

  return (
    <Input
      label={intl.formatMessage({id: "image_description"})}
      value={image_description}
      onChange={(e) => {
        setImageDescription(e.target.value);
        const newImages = [...imagesData];
        newImages.find(image => image.image_url === imageUrl).des_image = e.target.value;
        setImagesData(newImages);
      }}
      showErrorDialog={false}
    />
  )

};

export default WorksiteImageDescription;